import Text from "../components/main/Text"
import './styles/Welcome.css';
import { useMediaQuery } from "react-responsive";

interface BrandInfo {
  name?: string;
  logo?: string;
  claim?: string;
  primaryColor?: string;
}

function Welcome({ brand }: { brand?: BrandInfo } = {})
{
    const isMobile = useMediaQuery({ query: '(width <= 600px)' });

    const textProps =
    {
        fontSize: 28,
        lineHeight: '30px',
        letterSpacing: '0.35px',
        fontWeight: 700
    }

    if (brand?.name) {
        return (
            <div className = 'welcome-container' style = {{ flexDirection: 'column', gap: '36px' }}>
                {brand.logo && (
                    <div className = 'centered'>
                        <img src={brand.logo} alt={brand.name} style={{ maxHeight: 80 }} />
                    </div>
                )}
                <div className = 'title'>
                    <Text
                        text = {`Digitale Visitenkarten von ${brand.name}`}
                        {...{ ...textProps }}
                    />
                </div>
                {brand.claim && (
                    <div className = 'title'>
                        <Text
                            text = {brand.claim}
                            fontSize={16}
                            lineHeight='24px'
                            letterSpacing='0.35px'
                        />
                    </div>
                )}
            </div>
        )
    }

    return (
        <div className = 'welcome-container' style = {{ flexDirection: 'column', gap: '36px' }}>
            <div className = 'title'>
                <Text
                    text = 'Your digital vCard'
                    {...{ ...textProps }}
                />
            </div>

            <div className = 'centered' style = {{ flexDirection: isMobile ? 'column' : 'row', gap: '36px' }}>
                <img className = 'vcard-image image-shadow' src = './vcard.png' alt = 'vcard'/>

                <img className = 'image-shadow nfc-image' src = './nfc.png' alt = 'vcard'/>
            </div>

            <div className = 'link'>
                <Text
                    text = 'BMC-vCard'
                    {...{ ...textProps }}
                />
            </div>
        </div>
    )
}

export default Welcome